export const SET_DROPDOWN_CATEGORIES = "SET_DROPDOWN_CATEGORIES";

export const IS_FETCHING = "IS_FETCHING";
export const IS_ERROR = "IS_ERROR";
export const IS_SUCCESS = "IS_SUCCESS";
